






























import { defineComponent, ref } from "@nuxtjs/composition-api";
import PBHelper from "~/components/PageBuilder/utils/helper";
import PBComponent from "~/components/PageBuilder/utils/component";
const { loadAsyncComponent } = PBComponent();

export default defineComponent({
  name: "LayoutRow",
  components: {
    ...loadAsyncComponent(),
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
    dynamicBlocks: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { getComponentName } = PBHelper();
    const childComponents = ref([]);
    const isInner = () => props.children[0]["attr"]["data-element"] === "inner";

    const pb = {children: props.children};
    if (isInner()) {
      childComponents.value = pb.children[0]["child"];
    } else {
      childComponents.value = pb.children;
    }

    return {
      isInner,
      childComponents,
      getComponentName,
    };
  },
});
